// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"f12c194e","240":"9d821872","241":"571880c4","300":"17cfcbc6","395":"ea0c4234","570":"f961fb62","617":"88394ba4","649":"7eda194a","754":"0367e15f","960":"2a0631e5"}[chunkId] + ".chunk.js";
};